import ListingMetrics from './ListingMetrics.page';

export default ListingMetrics;